import { useQuery } from '@tanstack/react-query';
import {
  fetchLegacyUser,
  type LegacyUserDetail,
} from '../../services/legacyUserManager';

export const legacyUserDetailQueryKey = (userId: number) =>
  ['admin', 'legacy-users', 'detail', userId] as const;

export function useLegacyUserDetailQuery(userId: number | null) {
  return useQuery<LegacyUserDetail>({
    queryKey: legacyUserDetailQueryKey(userId ?? 0),
    queryFn: () => fetchLegacyUser(userId as number),
    enabled: userId != null && userId > 0,
  });
}
